import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';
import { App } from './App';
import { createRoot } from 'react-dom/client';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;
const rootElement = document.getElementById('root');
const root = createRoot(rootElement!); 

root.render(
    <BrowserRouter basename={baseUrl}>
        <Routes>
            <Route path="*" element={<App />}>
            </Route>
        </Routes>
    </BrowserRouter>
);